import { z } from "zod";

export const addOrUpdateProductSchema = z.object({
  category: z.string().min(1, "Category is required"),
  isSatisfied: z.boolean().optional(),
});

export type AddOrUpdateProductFormData = z.infer<
  typeof addOrUpdateProductSchema
>;

export const defaultValues: AddOrUpdateProductFormData = {
  category: "",
  isSatisfied: false,
};
